export default __webpack_public_path__ + "static/article-finance-getting-on-top-9022bf7165c9ebc09c6dc95769cbe100.jpg";